import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { ResourceType } from '../../../../types/resource';
import DeviationSidebarGrid from '../../../_partials/DeviationSidebarGrid';
import s from './TopicBlock.scss';

interface Props {
  parentDeviation: PapiDeviation;
  topicId: number;
  title: string;
  deviations: PapiDeviation[];
  linkTo?: string;
}

const TopicBlock: React.FC<React.PropsWithChildren<Props>> = ({
  topicId,
  title,
  deviations,
  parentDeviation,
  linkTo,
}) => {
  return (
    <BiLoggerContextProvider
      value={{
        sectionid: topicId,
        section_typeid: ResourceType.TOPIC,
      }}
    >
      <div className={s['root']}>
        <div className={s['topic-header']}>
          <BiLink className={s['topic-link']} href={linkTo}>
            {title}
          </BiLink>
        </div>
        <DeviationSidebarGrid
          streamId={`devpage-sidebar-topics-${parentDeviation.deviationId}-${topicId}`}
          className={s['topic-grid']}
          parentDeviation={parentDeviation}
          deviations={deviations}
          maxRows={1}
        />
      </div>
    </BiLoggerContextProvider>
  );
};
TopicBlock.displayName = 'TopicBlock';

export default TopicBlock;
